import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const Accordion = AccordionPrimitive.Root;

export const AccordionItem = styled(AccordionPrimitive.Item)(({ theme }) => ({
  borderRadius: 12,
  border: "1px solid #E5E7EB",
  backgroundColor: "#FFFFFF",
  marginBottom: 12,
  overflow: "hidden",
}));

export const AccordionTrigger = styled(AccordionPrimitive.Trigger)(({ theme }) => ({
  all: "unset",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "14px 16px",
  cursor: "pointer",
  fontSize: 15,
  fontWeight: 600,
  color: "#111827",
}));

export const AccordionContent = styled(AccordionPrimitive.Content)(({ theme }) => ({
  padding: "16px",
  backgroundColor: "#FAFAFA",
}));
